<template>
  <div ref="deviceTable">

    <health-widget icon="heart" title="Приборы" subtitle="Пожалуйста, введите данные с имеющихся приборов"/>

    <collapse-card open :loading="loadingDevice">
      <div slot="title">Станция здоровья</div>
      <div @click.stop="editHealthStation" slot="link" class="editHealthStationLink">Редактировать</div>

      <health-station :deviceData="healthStation" :editDeviceData="deviceModal"/>
    </collapse-card>

    <collapse-card open :loading="loadingDevice">
      <div slot="title">Показания приборов</div>

      <el-table
          :data="tableData"
          v-if="tableData"
          :show-header="false"
          class="table-data">
        <el-table-column scoped>
          <template slot-scope="scope">
            <div class="table-data__title">
              <el-tooltip v-if="scope.row.complete_data" content="Некоторые данные были заполнены" placement="top">
                <i class="el-icon-check"></i>
              </el-tooltip>
              {{ scope.row.title }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
            prop="address"
            align="right">
          <template slot-scope="scope">
            <el-button
                name="add"
                :ref="'deviceButton'+scope.row.id"
                @click="openDevice(scope.row)"
                aria-checked="true"
                :tabindex="scope.row.id"
                type="text"
            >
              Редактировать
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </collapse-card>

    <collapse-card :loading="loadingQuestionnaire">
      <div slot="title">Описание клиента</div>
      <questionnaire @onLoad="onLoadQuestionnaire" v-if="!loadingDevice" :type="120"></questionnaire>
    </collapse-card>


    <collapse-card :loading="loadingPoll">
      <div slot="title">Анамнез</div>
      <el-tabs
          class="poll-tab"
          v-if="!loadingQuestionnaire"
          v-model="tabPoll"
          :stretch="true">

        <el-tab-pane

            :label="item.title"
            :name="item.id.toString()"
            v-for="item of dataPoll.poll"
            :key="item.id"
        >

          <el-checkbox-group v-model="pollAnswers[item.id]">
            <el-checkbox-button v-for="tag in item.tag" :label="tag.id" :key="tag.id">{{ tag.text }}
            </el-checkbox-button>
          </el-checkbox-group>

          <div style="margin-top: 25px; float: right;">
            <el-button @click="submitPoll(item.id)" name="submitPoll" :loading="loadBtn">Сохранить теги</el-button>
          </div>

        </el-tab-pane>
      </el-tabs>
    </collapse-card>

    <card v-if="false" :loading="loadingPoll">

    </card>

    <div class="btns">
      <el-button type="primary" @click="closeSession" :loading="loadSend">Закрыть сессию</el-button>
      <el-button type="text" icon="el-icon-refresh-right" @click="loadLogic" :loading="loadSend">Обновить данные
      </el-button>
    </div>
    <edit-device-modal :device="thisDevice" :visible="deviceModal" @close="closeDeviceModal"/>

  </div>
</template>

<script>
import {mapActions, mapState} from "vuex"
import EditDeviceModal from "./modal/EditDeviceModal"

import Questionnaire from "@/modules/questionnaire/Questionnaire.vue"
import Card from "@/components/elements/Card.vue"
import CollapseCard from "@/components/elements/BigCard.vue"
import HealthWidget from "@/components/elements/HealthWidget.vue"
import HealthStation from "@/components/session/HealthStation.vue"

export default {
  name: "session.device",
  computed: {
    ...mapState("session", {
      session: (state) => state.session
    })
  },
  data: () => ({
    tableData: null,
    healthStation: null,
    loadBtn: false,
    loadingDevice: true,
    deviceModal: false,
    thisDevice: false,
    loadingPoll: true,
    loadingQuestionnaire: true,
    dataPoll: [],
    tabPoll: "1",
    poll: {
      type: []
    },
    pollAnswers: [],
    options: [],
    loadSend: false
  }),
  created() {
    if (!this.session) {
      this.$router.push({
        name: "session.create",
      })
    } else {
      this.loadLogic();
    }
  },
  components: {
    EditDeviceModal,
    Questionnaire,
    Card,
    CollapseCard,
    HealthWidget,
    HealthStation
  },
  methods: {
    ...mapActions({
      sessionSetStage: "session/SET_STAGE",
      getStageSession: "session/CURRENT",
      sessionClose: "session/CLOSE"
    }),
    closeDeviceModal(id) {
      this.deviceModal = false
      if (this.$refs["deviceButton" + id]) this.$refs["deviceButton" + id].$el.focus()
    },
    editHealthStation() {
      this.openDevice(this.healthStation)
    },
    loadLogic() {
      this.loadingQuestionnaire = true
      this.loadingDevice = true

      this.sessionSetStage(40)
      this.$api.session
          .getDevices(this.session.id)
          .then((response) => {
            this.tableData = response.data.filter(item => item.device_type !== "health_station")

            this.healthStation = response.data.find(item => item.device_type === "health_station")

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.loadingDevice = !!0
          })

    },
    onLoadQuestionnaire() {
      this.loadingQuestionnaire = false;
      this.loadPolls()
    },
    loadPolls() {

      this.loadingPoll = true;
      this.$api.session
          .getPoll(this.session.id)
          .then((response) => {
            this.dataPoll = response.data


            let poll = {}
            response.data.poll.forEach((i) => {
              poll[i.id] = []
            })

            response.data.answer.forEach((i) => {
              poll[1].push(i.id)
            })

            this.pollAnswers = poll
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки тагетированных анкет 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.loadingPoll = false;
          })


    },
    submitPoll(poll_id) {
      this.loadBtn = !!1

      this.$api.session.sendPoll(this.session.id, {
        poll_id,
        tag_id: this.pollAnswers[poll_id]
      }).then(() => {
        this.$notify.success({
          title: "Удачно!",
          message: "Данные тегов были сохранены",
        });
      }).catch((res) => {
        this.$notify.error({
          title: "Упс..",
          message: res.response.data.message,
        });
      }).finally(() => {
        this.loadBtn = !!0;
      });
    },

    closeSession() {
      this.error = null;
      if (this) {
        this.loadSend = true
        this.sessionClose(this.form)
            .then(() => {
              this.$notify.success({
                title: "Удачно...",
                message: "Сессия была закрыта",
              })

              this.$router.push({
                name: "session.create",
              })

              if (window.localStorage.getItem('session.comment')) window.localStorage.removeItem('session.comment', '')
            })
            .catch((response) => {
              this.$notify.error({
                title: "Ошибка закрытия сессии 😕",
                message: response.response.data.message,
              });
            })
            .finally(() => {
              this.loadSend = !!0;
            });
      }

    },
    openDevice(device) {
      this.thisDevice = device;
      this.deviceModal = !!1;
    },
    back() {
      this.$router.push({name: "session.questionnaire"})
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 650px;
  border: 0;
  border-radius: 8px;
  box-shadow: none;
  padding: 10px;
  background: #fff;
  margin: 0 0 10px 0;
}

.table-data {
  width: 100%;

  &__title {
    font-size: 14px;
  }
}

.btns {
  display: flex;
  align-items: center;
  justify-content: space-between;

  max-width: 650px;

  border-top: 1px solid #EAEAEA;

  margin-top: 33px;
  padding: 20px 0;
}

.poll-tab {
  margin-top: 16px;

  /deep/ .el-tabs__header {
    display: none;
  }
}

.el-icon-check {
  color: #43D3B3;
  margin-right: 5px;
}

button:focus {
  background: #cbf3e6 !important;
  color: #51D6AC !important;
}

.editHealthStationLink {
  font-size: 14px;
  text-decoration-line: underline;
  color: #43D3B3;

  transition: all .2s ease;

  &:hover {
    color: darken(#43D3B3, 10)
  }
}
</style>
